import JSZip from "jszip";
import { saveAs } from "file-saver";

const sanitizeAttachmentName = (name = "") =>
  String(name).replace(/[^a-zA-Z0-9]/g, "");

export const downloadAllAttachments = async ({
  attachments = [],
  zipName = "attachments.zip",
}) => {
  const normalizedAttachments = (Array.isArray(attachments) ? attachments : [])
    .map((item) => ({
      fileName: item?.FileName || item?.fileName || "",
      path: item?.Path || item?.path || "",
    }))
    .filter((item) => item.fileName && item.path);

  if (normalizedAttachments.length === 0) return false;

  const zip = new JSZip();
  const folder = zip.folder("attachments");

  await Promise.all(
    normalizedAttachments.map(async (attachment) => {
      const response = await fetch(attachment.path);
      if (!response.ok) {
        throw new Error(
          `Failed to fetch ${attachment.path}. Status: ${response.status}`,
        );
      }

      const blob = await response.blob();
      let nextFileName = attachment.fileName;
      let duplicateCount = 0;
      const originalFileName = nextFileName;

      while (folder.files[nextFileName]) {
        duplicateCount += 1;
        const lastDotIndex = originalFileName.lastIndexOf(".");
        const hasExtension = lastDotIndex !== -1;
        const nameWithoutExt = hasExtension
          ? originalFileName.substring(0, lastDotIndex)
          : originalFileName;
        const ext = hasExtension ? originalFileName.substring(lastDotIndex) : "";
        nextFileName = `${nameWithoutExt} (${duplicateCount})${ext}`;
      }

      folder.file(nextFileName, blob);
    }),
  );

  const zipBlob = await zip.generateAsync({ type: "blob" });
  const normalizedZipName = sanitizeAttachmentName(zipName.replace(/\.zip$/i, ""));
  saveAs(zipBlob, `${normalizedZipName || "attachments"}.zip`);
  return true;
};
